import { IStore } from '..';
import { GameState } from './reducer';

export const getGame = (state: IStore): GameState | null => {
    return state.game;
};
